<!--
 * @Author: Narcissus
 * @Date: 2022-10-25 18:41:51
 * @LastEditTime: 2022-11-02 09:44:06
 * @LastEditors: Narcissus
 * @Description:
 * @FilePath: \hi-tom\src\layout\components\head-nav\index.vue
-->
<!--  -->
<template>
  <div>
    <!-- <el-menu :default-active="this.$route.path" class="el-menu-demo" mode="horizontal" @select="handleSelect"
      background-color="#3c4348" text-color="#fff" active-text-color="#409EFF" :router='true'>
      <el-menu-item index="/">Home</el-menu-item>
      <el-submenu index="/mutation">
        <template slot="title">Mutation detection</template>
        <el-menu-item index="/mutation/primer">Primer design</el-menu-item>
        <el-menu-item index="/mutation/mutation_detection">Mutation detection</el-menu-item>
        <el-menu-item index="/mutation/sequence">Sequence composition analysis</el-menu-item>
        <el-menu-item><a href="http://www.hi-tom.net/hi-tom/"> Hi-TOM 1.0</a></el-menu-item>
      </el-submenu>
      <el-submenu index="/dna_methylation">
        <template slot="title">DNA methylation detection</template>
        <el-menu-item index="/dna_methylation/dna_primer">Primer design(MIP)</el-menu-item>
        <el-menu-item index="/dna_methylation/dna_methylation_detection">DNA methylation detection</el-menu-item>
      </el-submenu>
      <el-menu-item index="/help">Help</el-menu-item>
      <el-menu-item index="/contact">Contact</el-menu-item>
    </el-menu> -->
    <el-menu
      :default-active="this.$route.path"
      class="el-menu-demo"
      mode="horizontal"
      @select="handleSelect"
      background-color="#3c4348"
      text-color="#fff"
      active-text-color="#409EFF"
      :router="true"
    >
      <el-menu-item index="/">Home</el-menu-item>
      <el-submenu index="/mutation">
        <template slot="title">Primer design</template>
        <el-menu-item index="/mutation/primer"
          >Hi-TOM initial PCR primer design</el-menu-item
        >
        <el-menu-item index="/dna_methylation/dna_primer"
          >Methylation-Insensitive primer design</el-menu-item
        >
      </el-submenu>
      <el-submenu index="/dna_methylation">
        <template slot="title">Mutation detection</template>
        <el-menu-item index="/mutation/mutation_detection"
          >Mutation detection</el-menu-item
        >
        <el-menu-item index="/mutation/sequence"
          >Base-substitution mutation detection</el-menu-item
        >
        <el-menu-item index="/dna_methylation/dna_methylation_detection"
          >DNA methylation detection</el-menu-item
        >
        <el-menu-item
          ><a href="http://www.hi-tom.net/hi-tom/"> Hi-TOM 1.0</a></el-menu-item
        >
      </el-submenu>
      <el-menu-item index="/rare_mutation_detection"
        >Low-frequency mutation detection</el-menu-item
      >
      <el-menu-item index="/help">Help</el-menu-item>
      <el-menu-item index="/contact">Contact</el-menu-item>
    </el-menu>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeIndex: '1',
    };
  },

  components: {},

  computed: {},

  mounted() {},

  methods: {
    handleSelect(key, keyPath) {
      console.log(key);
      console.log(keyPath);
      console.log(event);
    },
  },
};
</script>
<style scoped>
a {
  text-decoration: none;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/layout/components/head-nav/index.vue